import { render, staticRenderFns } from "./LandingFonctionnalites.vue?vue&type=template&id=4a498c9f&scoped=true"
import script from "./LandingFonctionnalites.vue?vue&type=script&lang=js"
export * from "./LandingFonctionnalites.vue?vue&type=script&lang=js"
import style0 from "./LandingFonctionnalites.vue?vue&type=style&index=0&id=4a498c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a498c9f",
  null
  
)

export default component.exports